import { EbookProfileCard } from './EbookProfileCard'
import { withEbookProfileCard } from './withEbookCard'

const Connected = withEbookProfileCard(EbookProfileCard)

export { Connected as EbookProfileCard }
